import { isMobile } from '../utils/commonUtils'
import {
  SETTINGS_EDIT_MAMORIO,
  SETTINGS_EVENT_TRIGGERS,
  SETTINGS_GROUP_MANAGEMENT,
  SETTINGS_MAMORIO_SPOT,
  SETTINGS_QR_TAGS,
  SETTINGS_BIZ_ACCESS_LOGS,
} from './Paths'
import { teamHasQrTags } from '../helpers/qrTagFeature'

export interface SettingTabContent {
  label: string
  url: string
}

type SettingTabsOptions = {
  teamId?: number | null
  groups?: IGroup[] | null
  qrTagEnabled?: boolean | null
}

const SettingTabsInfo = ({ teamId = null, groups = null, qrTagEnabled = null }: SettingTabsOptions = {}): SettingTabContent[] => {
  const hostname = process.env.REACT_APP_HOSTNAME || window.location.hostname
  const teamDomain = hostname?.split('.')[0]
  const shouldShowEventTriggerTab = teamDomain === 'test_demo_biz' || teamId === 618 || teamId === 626
  const shouldShowQrTagTab = teamHasQrTags({ qr_tag_enabled: qrTagEnabled })
  const shouldShowBizAccessLogTab = Boolean(groups?.some((group) => group.biz_access_log_enabled))

  if (isMobile()) {
    const mobileTabs: SettingTabContent[] = [
      {
        label: 'MAMORIO',
        url: SETTINGS_EDIT_MAMORIO,
      },
      {
        label: 'グループ',
        url: SETTINGS_GROUP_MANAGEMENT,
      },
      {
        label: 'Spot',
        url: SETTINGS_MAMORIO_SPOT,
      },
    ]

    if (shouldShowQrTagTab) {
      mobileTabs.push({
        label: 'QRタグ',
        url: SETTINGS_QR_TAGS,
      })
    }

    if (shouldShowEventTriggerTab) {
      mobileTabs.push({
        label: 'イベント通知',
        url: SETTINGS_EVENT_TRIGGERS,
      })
    }

    if (shouldShowBizAccessLogTab) {
      mobileTabs.push({
        label: 'Bizアクセスログ',
        url: SETTINGS_BIZ_ACCESS_LOGS,
      })
    }

    return mobileTabs
  }

  const desktopTabs: SettingTabContent[] = [
    {
      label: 'MAMORIOの設定',
      url: SETTINGS_EDIT_MAMORIO,
    },
  ]

  if (shouldShowQrTagTab) {
    desktopTabs.push({
      label: 'QRタグの設定',
      url: SETTINGS_QR_TAGS,
    })
  }

  desktopTabs.push(
    {
      label: 'グループの管理',
      url: SETTINGS_GROUP_MANAGEMENT,
    },
    {
      label: 'MAMORIO Spotの管理',
      url: SETTINGS_MAMORIO_SPOT,
    },
  )

  if (shouldShowEventTriggerTab) {
    desktopTabs.push({
      label: 'イベント通知の管理',
      url: SETTINGS_EVENT_TRIGGERS,
    })
  }

  if (shouldShowBizAccessLogTab) {
    desktopTabs.push({
      label: 'Bizアクセスログ',
      url: SETTINGS_BIZ_ACCESS_LOGS,
    })
  }

  return desktopTabs
}

export default SettingTabsInfo
